











































































import {Component, Vue, Prop} from 'vue-property-decorator';
import {
  Action,
  Getter,
} from 'vuex-class';
import DlgPostsNew from '@/modules/admin/posts/_components/DlgPostsNew.vue';
import DlgPostsEdit from '@/modules/admin/posts/_components/DlgPostsEdit.vue';
import S3Image from '@/components/S3Image.vue';
import DlgPostsDelete from '@/modules/admin/posts/_components/DlgPostsDelete.vue';
import PostCommentField from '@/modules/admin/comments/_components/PostCommentField.vue';
import DeleteCommentField from '@/modules/admin/comments/_components/DeleteCommentField.vue';
import PostLikeField from '@/modules/admin/likes/_components/PostLikeField.vue';
import DlgPostsNewMobile from '@/modules/admin/posts/_components/DlgPostsNewMobile.vue';
import Loader from '@/components/Loader.vue';
import InfiniteLoading from 'vue-infinite-loading';
import S3Video from '@/components/S3Video.vue';

@Component({
  components: {
    S3Video,
    Loader,
    DlgPostsNewMobile,
    PostLikeField,
    DeleteCommentField,
    PostCommentField,
    DlgPostsDelete,
    S3Image,
    DlgPostsEdit,
    DlgPostsNew,
    InfiniteLoading,
  },
})
export default class PostsList extends Vue {
  private loading: boolean = false;
  private loadingComment: boolean = false;
  private comments: any = {};
  private loadingPost: any = {};
  private limit: any = 10;
  @Prop({type: String, default: ''}) private postId!: string;

  @Action('admin/posts/read') private readPosts!: () => Promise<boolean>;
  @Action('admin/posts/infiniteRead') private infiniteReadPosts!: () => Promise<boolean>;
  @Action('admin/animals/read') private readAnimals!: () => Promise<boolean>;

  @Getter('admin/posts/all') private posts!: any[];
  @Getter('admin/animals/all') private animals!: any[];
  @Getter('admin/posts/isAllLoaded') private isAllLoaded!: boolean;


  private mounted() {
    this.init();
  }

  private init() {
    this.loading = true;

    this.readAnimals()
      .then(() => {
        return this.readPosts();
      })
      .then((success) => {
        if (success) {
          this.loading = false;
        } else {
          throw new Error('Some Error, handle it');
        }
      })
      .catch((err) => {
        this.loading = false;
      });
  }

  private async infiniteHandler($state) {
    if (this.posts.length > this.limit) {
      this.limit += 10;
      return $state.loaded();
    }
    if (this.isAllLoaded) {
      return $state.complete();
    }
    await this.infiniteReadPosts();
    return $state.loaded();
  }

  private getAnimal(id: string) {
    for (const animal in this.animals) {
      if (this.animals[animal].id === id) {
        return this.animals[animal];
      }
    }
    return null;
  }

  private getAnimalProfileImage(animalId: string) {
    const animal = this.getAnimal(animalId);
    if (!animal || !animal.profileImage) {
      return '/img/animal/removed.png';
    } else {
      return animal.profileImage.replace('/full/', '/tiny/');
    }
  }

  private getAnimalTitle(animalId: string) {
    const animal = this.getAnimal(animalId);
    if (!animal) {
      return '- Deleted -';
    } else {
      return animal.title;
    }
  }

  private getPostText(description: string) {
    return description ? description.replace(/\n/gm, '<br/>') : '';
  }

  private goToAnimal(animalId: string) {
    this.$router.push({name: 'AdminAnimal', params: {id: animalId}});
  }

}
